import { NestedCheckboxGroupProps, toExtendedOption } from "@hightouch/formkit";
import { SharedProps } from ".";
import { Controller } from "react-hook-form";
import { NestedCheckBoxGroup } from "src/formkit/components";

export const FKNestedCheckboxGroup = ({
  name,
  options,
  isDisabled,
  query,
}: NestedCheckboxGroupProps & SharedProps) => (
  <Controller
    name={name}
    render={({ field }) => (
      <NestedCheckBoxGroup
        loading={query.isFetching}
        isDisabled={isDisabled}
        options={toExtendedOption(query.enabled ? query.data : options)}
        reload={query.refetch}
        value={field.value || []}
        onChange={(newValue: string[]) => {
          field.onChange(newValue ?? []);
        }}
      />
    )}
  />
);
